import MacroComponent from './MacroComponent.vue';
export const Macro = {
    install(Vue, options = {}) {
        if (this.installed) return;
        this.installed = true;
        if (!options.applicationName) throw new Error("Please provide applicationName in option, without applicationName macro will not work");
        options.macroJSFileUrl = options.macroJSFileUrl || "/Framewrk/subs/macro.js";
        Vue.mixin({
            data: () => ({ appName: options.applicationName, macroJSFileUrl: options.macroJSFileUrl }),
            methods: {
                getThisReference() {
                    return function (reference) {
                        if (reference) return this.$refs[reference];
                        return this;
                    }.bind(this)
                }
            }
        });
        Vue.component('MacroComponent', MacroComponent);
    }
};